import Image from "next/image";
import {LOCAL_IMAGE_URL} from "@/constants/general-constants";

export default function GoogleLogo() {
    return (
        <div className="relative w-8 h-8">
            <Image
                src={LOCAL_IMAGE_URL+"google-logo.webp"}
                fill
                alt="Google Logo"
            />
        </div>
    )
}
